import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  user = {
    id: null,
    mid: null,
    spwd: null,
    mpwd: null,
    accepted: false
  };
  apistr = '/api/veexinc/veexweb';
  constructor(
    private _http: HttpClient,) { }
  // Login
  login(loginCredentials: { type?: string; id: any; mid?: any; spwd: any; mpwd?: any; }): any {
    this.user = {
      id: loginCredentials.id,
      mid: loginCredentials.mid,
      spwd: loginCredentials.spwd,
      mpwd: loginCredentials.mpwd,
      accepted: false
    };
    const login = {
      type: 'login',
      id: loginCredentials.id,
      pwd: loginCredentials.spwd
    };
    // console.log(this.user);
    return this._http.post(this.apistr, login);
  }

  loginAccepted(): void {
    this.user.accepted = true;
  }
  rememberMe(): void {
    // console.log(this.user);
    localStorage.setItem('login', JSON.stringify(this.user));
  }
  getRememberMe(): void {
    if (localStorage.getItem('login')) {
      const tempuser = JSON.parse(localStorage.getItem('login'));
      // console.log('tempuser', tempuser);
      const loginCredentials = {
        type: 'login',
        id: tempuser.id,
        mid: tempuser.mid,
        spwd: tempuser.spwd,
        mpwd: tempuser.mpwd
      };
      this.login(loginCredentials).subscribe(data => {
        // console.log('remember data', data);
        if ((data as any).status_code === '000') {
          this.user = tempuser;
          // console.log('GOT REMEMBER ME', this.user);
        }
      });
    }
  }

  logout(): void {
    // console.log('Logout');
    localStorage.removeItem('login');
    localStorage.removeItem('user');
    localStorage.clear();
    this.user = {
      id: null,
      mid: null,
      spwd: null,
      mpwd: null,
      accepted: false
    };
  }
  getCust(): any {
    if (localStorage.getItem('user')) {
      const customer = JSON.parse(localStorage.getItem('user'));
      return customer.result.info;
    } else {
      return false;
    }
  }
}
